import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstace from "../../api/axiosInstance";

export const fetchDataExams = createAsyncThunk(
  "api/fetchDataExams",
  async ({ page = 1, limit = 8, searchQuery = "" }) => {
    try {
      const response = await axiosInstace.get("/test", {
        params: {
          page,
          limit,
          value: searchQuery,
        },
      });

      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const getTestsNoPagination = createAsyncThunk(
  "api/getTestsNoPagination",
  async () => {
    try {
      const response = await axiosInstace.get("/test/getTestsNoPagination");
      console.log("🚀 ~ response:", response.data);

      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const createDataExams = createAsyncThunk(
  "api/createDataExams",
  async (createDataExams) => {
    try {
      const response = await axiosInstace.post(
        "/test/addTest",
        createDataExams
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const updateDataExams = createAsyncThunk(
  "api/updateTest",
  async ({ id, updatedData }) => {
    try {
      const response = await axiosInstace.put(
        `/test/updateTest/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const deleteDataExams = createAsyncThunk(
  "apiQuestion/deleteDataExams",
  async (itemId) => {
    try {
      await axiosInstace.delete(`/test/deleteTest/${itemId}`);
      return itemId;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

const apiExamsSlice = createSlice({
  name: "apiExams",
  initialState: {
    data: [],
    getTest: [],
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    loading: false,
    error: null,
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataExams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDataExams.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.totalPages = action.payload.totalPages;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(fetchDataExams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getTestsNoPagination.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTestsNoPagination.fulfilled, (state, action) => {
        state.loading = false;
        state.getTest = action.payload;
      })
      .addCase(getTestsNoPagination.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createDataExams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDataExams.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data.push(action.payload);
        }
      })
      .addCase(createDataExams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateDataExams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDataExams.fulfilled, (state, action) => {
        const updatedData = action.payload;

        if (state.data && Array.isArray(state.data.data)) {
          const index = state.data.data.findIndex(
            (item) => item.id === updatedData.id
          );
          if (index !== -1) {
            state.data.data[index] = updatedData;
          }
        } else {
          console.warn(
            "Expected state.data.data to be an array but got:",
            state.data
          );
        }

        state.loading = false;
      })
      .addCase(updateDataExams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteDataExams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDataExams.fulfilled, (state, action) => {
        const deletedItemId = action.payload;
        if (Array.isArray(state.data?.data)) {
          state.data.data = state.data.data.filter(
            (item) => item.id !== deletedItemId
          );
        }
        state.loading = false;
      })
      .addCase(deleteDataExams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setPage } = apiExamsSlice.actions;

export default apiExamsSlice.reducer;
